/**
 * BLOCK - CAROUSEL PRODUCTS - LISTENERS
 */

setupEventListenersForProductsCarousel();

// Creates the event listeners
function setupEventListenersForProductsCarousel() {
  // On clicking on a tag in the tag switcher
  document.querySelectorAll('[data-action="change-products-list-tag"]').forEach((element) => {
    element.addEventListener('click', clickTagSwitcherHandler);
  });
  
  // On changing the slide of a carousel product
  document.querySelectorAll('.carousel--products[data-after-change="true"]').forEach((element) => {
    element.addEventListener('afterChange', changeProductsCarouselSlideHandler);
  });
}

/**
 * BLOCK - CAROUSEL PRODUCTS - GENERAL
 */

// On clicking on a tag in the tag switcher
function clickTagSwitcherHandler() {   
  if (!event.currentTarget.classList.contains('selected')) {
    changeProductsCarouselCurrentProduct();
    changeTagsSwitcherStyle(event.currentTarget);
    changeProductsCarouselSectionColors();
  }
}

// On changing the slide of a carousel product
function changeProductsCarouselSlideHandler() {
  checkTagsSwitcher();
  changeProductsCarouselSectionColors();
}

// Changes the product displayed in the products carousel
function changeProductsCarouselCurrentProduct() {
  var target = event.currentTarget,
      section = target.closest('.block__page'),
      carousel = section.querySelector('.carousel--products'),
      cells = carousel.querySelectorAll('.carousel-cell'),
      switcherTag = target.closest('.products-tag'),
      tagTarget = switcherTag.dataset.target;
  
  event.preventDefault();
  
  cells.forEach((element) => {
    var itemProduct = element.querySelector('.item-product'),
        productTags = itemProduct.dataset.productTags;
    
    if (productTags.indexOf(tagTarget) != -1) {
      carousel.closest('.carousel').swiper.slideTo(parseInt(element.dataset.slideIndex), parseInt(carousel.dataset.speed), false);
      
      return false;
    }         
  });
}

// Changes the tags switcher style
function changeTagsSwitcherStyle(element) {
  var selectedSwitcherTag = element.closest('.products-tag'),
      oldSwitcherTag = selectedSwitcherTag.parentNode.querySelector('.selected');
  
  if (oldSwitcherTag !== null) oldSwitcherTag.classList.remove('selected');
  if (selectedSwitcherTag !== null) selectedSwitcherTag.classList.add('selected');
}

// Changes the colours of the section containing the products carousel
function changeProductsCarouselSectionColors() {
  var target = event.currentTarget,
      section = target.closest('.block__page'),
      carousel = section.querySelector('.carousel--products'),
      changeSectionColors = carousel.dataset.changeSectionColors,
      changeSectionBgColors = carousel.dataset.changeSectionBgColors,
      changeSectionTagsSwitcherColors = carousel.dataset.changeSectionTagsSwitcherColors,
      changeSectionButtonsColors = carousel.dataset.changeSectionButtonsColors;
  
  if (changeSectionColors) {
    var tagsSwitcher = section.querySelector('.block.block__products-tags-switcher'),
        switcherTagsNotSelected = tagsSwitcher.querySelectorAll('.products-tag:not(.selected) .products-tag__button'),
        switcherTagSelected = tagsSwitcher.querySelectorAll('.products-tag.selected .products-tag__button'),
        currentSlide = carousel.querySelector('.swiper-slide-active'),
        currentProduct = currentSlide.querySelector('.item-product'),
        button1 = section.querySelectorAll('.block.block__button')[0],
        button2 = section.querySelectorAll('.block.block__button')[1],
        productUrl = currentProduct.dataset.productUrl,
        productColor1 = currentProduct.dataset.productColor-1,
        productColor2 = currentProduct.dataset.productColor-2,
        gradientStyle = section.dataset.gradientStyle,
        gradientDegree = section.dataset.gradientDegree,
        gradientPercent1 = section.dataset.gradientPercent-1,
        gradientPercent2 = section.dataset.gradientPercent-2;

    // Changes the background colour of the section
    if (changeSectionBgColors) {
      if (gradientStyle == 'linear') {
        section.style.setProperty('--section-color-bg', 'linear-gradient(' + gradientDegree + 'deg, ' + productColor2 + ' ' + gradientPercent1 + '%, ' + productColor1 + ' ' + gradientPercent2 + '%)');
      } else {
        section.style.setProperty('--section-color-bg', 'radial-gradient(' + productColor1 + ' ' + gradientPercent1 + '%, ' + productColor2 + ' ' + gradientPercent2 + '%)');
      }
    }

    // Changes the colours of the tags switcher
    if (changeSectionTagsSwitcherColors && tagsSwitcher !== null) {
      switcherTagsNotSelected.forEach((element) => {
        element.style.setProperty('--btn-color-text', productColor1);
        element.style.setProperty('--btn-color-text-hover', productColor1);
        element.style.setProperty('--btn-color-bg', '');
        element.style.setProperty('--btn-color-bg-hover', '');
      });
      
      switcherTagSelected.forEach((element) => {
        element.style.setProperty('--btn-color-bg', productColor1);
        element.style.setProperty('--btn-color-bg-hover', productColor1);
        element.style.setProperty('--btn-color-text', '');
        element.style.setProperty('--btn-color-text-hover', '');
      });
    }

    // Changes the colours of the buttons
    if (changeSectionButtonsColors) {
      if (button2 !== undefined) {
        if (button1 !== undefined) {
          button1.style.setProperty('--btn-color-bg', productColor1);
          button1.style.setProperty('--btn-color-bg-hover', productColor1);
          button1.style.setProperty('--btn-borders-color', productColor1);
        }
        button2.style.setProperty('--btn-color-text', productColor1);
        button2.style.setProperty('--btn-color-text-hover', productColor1);
        button2.querySelector('.button').setAttribute('href', productUrl);
      } else if (button1 !== undefined) {
        if (button1.getAttribute('href') == '#') {
          button1.style.setProperty('--btn-color-bg', productColor1);
          button1.style.setProperty('--btn-color-bg-hover', productColor1);
          button1.style.setProperty('--btn-borders-color', productColor1);
        } else {
          button1.style.setProperty('--btn-color-text', productColor1);
          button1.style.setProperty('--btn-color-text-hover', productColor1);
          button1.querySelector('.button').setAttribute('href', productUrl);
        }
      }
    }
  }
}

// Checks if the selected tag should change
function checkTagsSwitcher() {
  var target = event.currentTarget,
      section = target.closest('.block__page'),
      tagsSwitcher = section.querySelector('.block.block__products-tags-switcher'),
      switcherTags = tagsSwitcher.querySelectorAll('.products-tag'),
      carousel = section.querySelector('.carousel--products'),
      currentSlide = carousel.querySelector('.swiper-slide-active'),
      currentProduct = currentSlide.querySelector('.item-product'),
      currentProductTags = currentProduct.dataset.productTags;
  
  switcherTags.forEach((element) => {
    var tagTarget = element.data('target');
    
    if (currentProductTags.indexOf(tagTarget) != -1) {
      changeTagsSwitcherStyle(element);
      
      return false;
    }
  });
}